document.addEventListener('DOMContentLoaded', function () {
    var contactForm = document.getElementById('isolta-contact-us-form');
    var emailInput = document.getElementById('isolta_contact_us_email');
    var messageInput = document.getElementById('isolta_contact_us_message');
    var submitButton = document.getElementById('isolta_contact_us_submit');
    var getDomain = window.location.hostname;
    
    // check if form exists to avoid console errors
    if (contactForm ) {
    var loadingDiv;
    var fieldsOgColor = emailInput.style.backgroundColor;
    var buttonOgColor = submitButton.style.backgroundColor;
    var borderOgColor = emailInput.style.borderColor;


    // Different language responses for js functions
    var checkLang = document.documentElement.lang;

    let sendErrorText;
    let sendingText;
    let emailErrorText;
    let requiredFieldErrorText;
    let thankYouMessage;


    switch (checkLang) {
        case "fi":
            sendErrorText = 'Viestin lähettäminen epäonnistui, yritä kohta uudelleen';
            sendingText = 'Viestiä lähetetään...';
            requiredFieldErrorText = 'Täytä pakollinen kenttä';
            emailErrorText = 'Sähköpostiosoite on virheellinen';
            thankYouMessage = 'Kiitos viestistäsi';
            break;
        case "en":
            sendErrorText = 'Failed to send message, please try again later';
            sendingText = 'Sending message...';
            requiredFieldErrorText = 'Fill in the required field';
            emailErrorText = 'Invalid email address';
            thankYouMessage = 'Thank you for your message';
            break;
        case "sv-SE":
            sendErrorText = 'Misslyckades att skicka meddelandet, försök igen senare';
            sendingText = 'Skickar meddelande...';
            requiredFieldErrorText = 'Fyll i det obligatoriska fältet';
            emailErrorText = 'Ogiltig e-postadress';
            thankYouMessage = 'Tack för ditt meddelande';
            break;
        case "sv-FI":
            sendErrorText = 'Misslyckades att skicka meddelandet, försök igen senare';
            sendingText = 'Skickar meddelande...';
            requiredFieldErrorText = 'Fyll i det obligatoriska fältet';
            emailErrorText = 'Ogiltig e-postadress';
            thankYouMessage = 'Tack för ditt meddelande';
            break;
        case "ru":
            sendErrorText = 'Не удалось отправить сообщение, попробуйте позже';
            sendingText = 'Отправка сообщения...';
            requiredFieldErrorText = 'Заполните обязательное поле';
            emailErrorText = 'Неверный адрес электронной почты';
            thankYouMessage = 'Спасибо за ваше сообщение';
            break;
        case "ru-FI":
            sendErrorText = 'Не удалось отправить сообщение, попробуйте позже';
            sendingText = 'Отправка сообщения...';
            requiredFieldErrorText = 'Заполните обязательное поле';
            emailErrorText = 'Неверный адрес электронной почты';
            thankYouMessage = 'Спасибо за ваше сообщение';
            break;
        case "ru-EE":
            sendErrorText = 'Не удалось отправить сообщение, попробуйте позже';
            sendingText = 'Отправка сообщения...';
            requiredFieldErrorText = 'Заполните обязательное поле';
            emailErrorText = 'Неверный адрес электронной почты';
            thankYouMessage = 'Спасибо за ваше сообщение';
            break;
        case "ru-LV":
            sendErrorText = 'Не удалось отправить сообщение, попробуйте позже';
            sendingText = 'Отправка сообщения...';
            requiredFieldErrorText = 'Заполните обязательное поле';
            emailErrorText = 'Неверный адрес электронной почты';
            thankYouMessage = 'Спасибо за ваше сообщение';
            break;
        case "et":
            sendErrorText = 'Sõnumi saatmine ebaõnnestus, proovige hiljem uuesti';
            sendingText = 'Sõnumi saatmine...';
            requiredFieldErrorText = 'Täitke kohustuslik väli';
            emailErrorText = 'Vigane e-posti aadress';
            thankYouMessage = 'Täname teie sõnumi eest';
            break;
        case "lv":
            sendErrorText = 'Neizdevās nosūtīt ziņojumu, lūdzu, mēģiniet vēlāk';
            sendingText = 'Nosūta ziņojumu...';
            requiredFieldErrorText = 'Aizpildiet obligāto lauku';
            emailErrorText = 'Nederīga e-pasta adrese';
            thankYouMessage = 'Paldies par jūsu ziņojumu';
            break;
        case "de":
            sendErrorText = 'Das Senden der Nachricht ist fehlgeschlagen. Bitte versuchen Sie es später noch einmal';
            sendingText = 'Schicke Nachricht...';
            requiredFieldErrorText = 'Füllen Sie das erforderliche Feld aus';
            emailErrorText = 'Ungültige E-Mail-Adresse';
            thankYouMessage = 'Danke für deine Nachricht';
            break;
    default:
        sendErrorText = 'Failed to send message, please try again later';
        sendingText = 'Sending message...';
        requiredFieldErrorText = 'Fill in the required field';
        emailErrorText = 'Invalid email address';
        thankYouMessage = 'Thank you for your message';
    }

    


    // This function is running when user clicks send button on contact us form
    function userHasClickedSendButton()  {
        if (loadingDiv) {
            loadingDiv.remove();
            }
    
           
            loadingDiv = document.createElement('div');
            loadingDiv.textContent = sendingText;
            loadingDiv.classList.add('form-action', 'form-action__sending'); 
    
    
            submitButton.parentNode.insertBefore(loadingDiv, submitButton.nextSibling);

    
            emailInput.style.backgroundColor = '#80808085';
            messageInput.style.backgroundColor = '#80808085';
            submitButton.style.backgroundColor = '#80808085';
    
            emailInput.style.cursor = 'not-allowed';
            messageInput.style.cursor = 'not-allowed';
            submitButton.style.cursor = 'not-allowed';
    
            // Disabloi kentät
            emailInput.disabled = true;
            messageInput.disabled = true;
            submitButton.disabled = true;
    }

    // Sending form has failed
    function formFailed() {
        emailInput.style.backgroundColor = fieldsOgColor;
        messageInput.style.backgroundColor = fieldsOgColor;
        submitButton.style.backgroundColor = buttonOgColor;

        emailInput.style.cursor = 'unset';
        messageInput.style.cursor = 'unset';
        submitButton.style.cursor = 'unset';

        // Palauta kentät käyttöön
        emailInput.disabled = false;
        messageInput.disabled = false;
        submitButton.disabled = false;

        loadingDiv.textContent = sendErrorText;
        loadingDiv.classList.add('form-action__error');
    }

        // If email field has empty error, then start checking
        emailInput.addEventListener('input', function() {
            var errorMessage = emailInput.nextElementSibling;
            if (errorMessage && errorMessage.classList.contains('required-field-error-message')) {
                var regex = /@.+?\..{2,}/;
                if (!regex.test(emailInput.value)) {
                errorMessage.textContent = emailErrorText;
            } else {
                errorMessage.remove();
                emailInput.style.borderColor = borderOgColor;
            }
        }
        });
   

   
    // Form submission
    contactForm.addEventListener('submit', function (e) {
        e.preventDefault();

        var virheElementit = document.querySelectorAll('.required-field-error-message');
        virheElementit.forEach(function(elementti) {
            elementti.remove();
        });

        var emailRegex = /@.+?\..{2,}/;

        // Email validation
        if (!emailInput.value) {
    
        emailInput.style.borderColor = "red";

        var newErrorMessage = document.createElement('span');
        newErrorMessage.className = 'required-field-error-message';
        newErrorMessage.textContent = requiredFieldErrorText;
        emailInput.parentNode.insertBefore(newErrorMessage, emailInput.nextSibling);
        } else if (!emailRegex.test(emailInput.value)) {
        emailInput.style.borderColor = "red";

        var newErrorMessage = document.createElement('span');
        newErrorMessage.className = 'required-field-error-message';
        newErrorMessage.textContent = emailErrorText;
        emailInput.parentNode.insertBefore(newErrorMessage, emailInput.nextSibling);
        } else {
            emailInput.style.borderColor = borderOgColor;
        }



        // Message validation
        if (!messageInput.value) {
            
            messageInput.style.borderColor = "red";
    
            var newErrorMessage = document.createElement('span');
            newErrorMessage.className = 'required-field-error-message';
            newErrorMessage.textContent = requiredFieldErrorText;
    
            messageInput.parentNode.insertBefore(newErrorMessage, messageInput.nextSibling);
                
            } else {
                messageInput.style.borderColor = borderOgColor;
            }

            // If email or message field is empty, don't complete form
            if (!emailInput.value || !messageInput.value) {
                return;
            }


        var ajaxurl = '/wp-admin/admin-ajax.php';
        var data = new URLSearchParams();
        data.append('action', 'isolta_contact_us_handler');
        data.append('subject', emailInput.value);
        data.append('message', messageInput.value);

        userHasClickedSendButton();

        fetch(ajaxurl, {
            method: 'POST',
            body: data,
        })
        .then(function (response) {
            return response.json();
        })
        .then(function (responseData) {

            if (responseData.success) {
                contactForm.innerHTML = "<h3 style='text-align: center;'>" + thankYouMessage + "</h3><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' style='height: 164px; width: 164px; display: flex; margin: 32px auto;'><path fill='#D2E3CB' d='M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z' /></svg>";
            } else {
                formFailed();
            }
        })
        .catch(function (error) {
            formFailed();
            console.error('Virhe lähetyksessä:', error);
        });
    });
}
});